
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button/button';
import React, { useRef, useState } from 'react';
import { IModuleParam } from '../../../redux/progress/module/moduleInterface';
import { IFileInfo } from './fileinfo.interfact';

export interface LocalButtonPropies extends ButtonProps {
    children?: React.ReactNode;
    param: IModuleParam;
    onFileChanged?: (fileInfo: IFileInfo) => void;
    fileValue?: IFileInfo;
}

export default function LocalButton(props: LocalButtonPropies) {
    const { children, param, ...buttonProps } = props;

    const [loading, setLoading] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    if (param.FILESOURCE !== 'LOCAL') {
        return <>{children}</>
    }

    return <>
        <Button {...buttonProps} loading={loading} onClick={() => {
            inputRef.current?.click();
        }}>...</Button>
        <input
            type="file"
            style={{ visibility: 'hidden', width: 0, height: 0, border: 0 }}
            ref={inputRef}
            onChange={(e) => {
                const file = e.target.files ? e.target.files[0] : null;
                if (file) {
                    setLoading(true);
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const some = reader.result;
                        if (props.onFileChanged) {
                            props.onFileChanged({
                                name: file.name,
                                content: some as string,
                            });
                        }
                        setLoading(false);
                    };
                    reader.readAsText(file);
                }
            }}
        />
    </>
}